import React from 'react';

import Layout from '../components/layout';
import SearchBar from '../components/searchBar';
import SEO from '../components/seo';

const IndexPage = () => (
  <Layout>
    <SEO title="Search" description="A Knowledge Base for Growtopia Game." />
    <SearchBar />
  </Layout>
);

export default IndexPage;
